import Service from "../api/service";
import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "user",
  client: "service",
  listPath: "auth/admin/user",
  adminPath: "auth/admin/user",
  adminPrefix: "",
  omit: ["create", "update"],
  legacy: {
    data: "users",
    count: "count",
    fetch: "fetchUsers",
    remove: "deleteUser",
    updateState: "updateUserState",
  },
  extras: () => ({
    // Users have two distinct update endpoints — profile and password.
    updateUserProfile: async (user_id, payload) =>
      Service.post(`/api/v1/auth/admin/user/update/profile/${user_id}`, payload),
    updateUserPassword: async (user_id, payload) =>
      Service.post(
        `/api/v1/auth/admin/user/update/password/${user_id}`,
        payload,
      ),
  }),
});

export const UserProvider = Provider;
export const useUserContext = useValue;
